const MEALS_URL = 'https://www.themealdb.com/api/json/v1';
const DRINKS_URL = 'https://www.thecocktaildb.com/api/json/v1';
const ERROR_MESSAGE = 'Não foram encontradas receitas!';
const MAX_INGREDIENTS = 12;
const MAX_RECIPES = 12;

export const getIngredients = async (type) => {
  let url;
  if (type === 'meals') {
    url = `${MEALS_URL}/1/list.php?i=list`;
  } else {
    url = `${DRINKS_URL}/1/list.php?i=list`;
  }
  const response = await fetch(url);
  const data = await response.json();

  return data[type].slice(0, MAX_INGREDIENTS);
};

const getToken = (key) => {
  const token = localStorage.getItem(key);
  const parsedToken = token ? JSON.parse(token) : '1';

  return parsedToken;
};

const getTypeInfo = (type) => {
  if (type === 'meals') {
    return [getToken('mealsToken'), MEALS_URL];
  }
  return [getToken('cocktailsToken'), DRINKS_URL];
};

export const getRecipesByIngredient = async (type, ingredient) => {
  const [typeToken, typeUrl] = getTypeInfo(type);

  const response = await fetch(
    `${typeUrl}/${typeToken}/filter.php?i=${ingredient}`,
  );
  const data = await response.json();

  if (!data[type]) throw new Error(ERROR_MESSAGE);

  return data[type].slice(0, MAX_RECIPES);
};
